import {Button} from "omoplay";
import BookIcon from "../../assets/images/icon.book.blue.svg";


const GuideButtonFrom = ({buttonName, url}) => {
    return (
        <div className="flex">
            <Button variants="outlined" style={{borderColor: "var(--shape-primary)"}} value={
                <div className="flex-align-center">
                    <img alt="" src={BookIcon} width="16px" height="16px" />
                    <div className="ml-2 text-primary font-bold">{buttonName}</div>
                </div>
            } onClick={() => {
                window.open(url)
            }} />
        </div>
    )
}

export default GuideButtonFrom